// import React from 'react';

// const ServicesSection = () => {
//   const services = [
//     {
//       icon: "lni lni-capsule",
//       title: "Refreshing Design",
//       description: "Lorem ipsum dolor sit amet, adipscing elitr, sed diam nonumy eirmod tempor ividunt labor dolore magna."
//     },
//     {
//       icon: "lni lni-bootstrap",
//       title: "Solid Bootstrap 5",
//       description: "Lorem ipsum dolor sit amet, adipscing elitr, sed diam nonumy eirmod tempor ividunt labor dolore magna."
//     },
//     {
//       icon: "lni lni-shortcode",
//       title: "100+ Components",
//       description: "Lorem ipsum dolor sit amet, adipscing elitr, sed diam nonumy eirmod tempor ividunt labor dolore magna."
//     },
//     {
//       icon: "lni lni-dashboard",
//       title: "Speed Optimized",
//       description: "Lorem ipsum dolor sit amet, adipscing elitr, sed diam nonumy eirmod tempor ividunt labor dolore magna."
//     },
//     {
//       icon: "lni lni-layers",
//       title: "Fully Customizable",
//       description: "Lorem ipsum dolor sit amet, adipscing elitr, sed diam nonumy eirmod tempor ividunt labor dolore magna."
//     },
//     {
//       icon: "lni lni-reload",
//       title: "Regular Updates",
//       description: "Lorem ipsum dolor sit amet, adipscing elitr, sed diam nonumy eirmod tempor ividunt labor dolore magna."
//     }
//   ];

//   return (
//     <section id="services" className="services-area services-eight">
//       <div className="section-title-five">
//         <div className="container">
//           <div className="row">
//             <div className="col-12">
//               <div className="content">
//                 <h6>Services</h6>
//                 <h2 className="fw-bold">Our Best Services</h2>
//                 <p>
//                   There are many variations of passages of Lorem Ipsum available,
//                   but the majority have suffered alteration in some form.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="container">
//         <div className="row">
//           {services.map((service, index) => (
//             <div key={index} className="col-lg-4 col-md-6">
//               <div className="single-services">
//                 <div className="service-icon">
//                   <i className={service.icon}></i>
//                 </div>
//                 <div className="service-content">
//                   <h4>{service.title}</h4>
//                   <p>{service.description}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ServicesSection;
import React from "react";

const ServicesSection = () => {
  const services = [
    {
      icon: "lni lni-cog",
      title: "IT Hardware Supply",
      description:
        "Supply and installation of servers, networking devices, CCTV systems, biometric devices, and enterprise-grade hardware solutions."
    },
    {
      icon: "lni lni-network",
      title: "Network & Security Solutions",
      description:
        "Professional network design, structured cabling, firewall setup, CCTV surveillance, and access control systems."
    },
    {
      icon: "lni lni-code",
      title: "Software Development",
      description:
        "Custom software development including web applications, management systems, APIs, and business automation tools."
    },
    {
      icon: "lni lni-cloud",
      title: "Cloud & Server Solutions",
      description:
        "Cloud deployment, on-premise server setup, backup solutions, virtualization, and system performance optimization."
    },
    {
      icon: "lni lni-laptop-phone",
      title: "IT Support & Maintenance",
      description:
        "Annual maintenance contracts, troubleshooting, upgrades, and reliable technical support for businesses."
    },
    {
      icon: "lni lni-shield",
      title: "System Integration & Consulting",
      description:
        "End-to-end IT consulting, system integration, technology planning, and scalable digital transformation solutions."
    }
  ];

  return (
    <section id="services" className="services-area services-eight">
      <div className="section-title-five">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="content">
                <h6>Services</h6>
                <h2 className="fw-bold">Our Best Services</h2>
                <p>
                  We deliver reliable hardware solutions and scalable software
                  services tailored to modern business needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="single-services">
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <div className="service-content">
                  <h4>{service.title}</h4>
                  <p>{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
